import React, { useContext, useEffect, useRef } from "react";
import useState from "react-usestateref";
import Header from "./Header";
import Sidebar from "./Sidebar";
import { Link, useNavigate } from "react-router-dom";
import authService from "../services/authservices";
import { UserContext } from "../contexts/UserContext";
import { ToastContainer, toast } from "react-toastify";
import { getUserDetails } from "../services/authservices";
import { getExchanges } from "../services/authservices";
import "react-toastify/dist/ReactToastify.css";
import { ScaleLoader } from "react-spinners";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import i18n from "../translate/i18n";
function ApiBind() {
  const [otpSent, setOtpSent, otpSentref] = useState(false);
  const [timer, setTimer, timerref] = useState(120);
  const { t } = useTranslation();

  const [exchanges, setExchanges] = useState([]);
  const [exchangeOptions, setExchangeOptions] = useState([]); // Stores the formatted options for the dropdown
  const [planDetails, setPlanDetails] = useState([]);
  const [onlythree, setOnlythree] = useState(false);

  const [formStates, setFormStates] = useState({});
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");

  const [toastVisible, setToastVisible] = useState(false);
  const [resendLoader, setResendLoader, resendLoaderref] = useState(false);
  const [user, setUser] = useState({
    tfaStatus: 0,
    email: null,
    uid: null,
    referralCode: null,
    referralUrl: null,
    displayname: null,
    country: null,
    isAuthenticated: false,
    exchanges: [],
  });

  const [loading, setLoading] = useState(true);
  const [content, setContent] = useState("Disable");
  const [error, setError] = useState("");

  const handleToggle = async (index, exchangeName, status) => {
    // console.log("exchangeName====", exchangeName, status);
    //setContent((prev) => (prev === "Disable" ? "Enable" : "Disable"));
    try {
      const storeResponse = await authService.updateApiStatus({
        status,
        exchangeName,
      });
      // console.log(storeResponse, "storeResponse");
      if (storeResponse) {
        showSuccessToast(storeResponse.message);
        fetchUserDetails();
      } else {
        showErrorToast("Something went wrong, Please try again");
      }
    } catch (error) {}
  };

  const [i18nextLngs, seti18nextLngs] = useState(
    localStorage.getItem("i18nextLng") || "en" || "et" || "fi"
  );
  useEffect(() => {
    if (i18nextLngs === "en") {
      i18n.changeLanguage(i18nextLngs);
      document.documentElement.lang = i18nextLngs;
    }
  }, [i18nextLngs]);

  useEffect(() => {
    const storedTheme = localStorage.getItem("theme");
    if (storedTheme) {
      setTheme(storedTheme);
    }
  }, []);

  const showErrorToast = (message) => {
    if (!toastVisible) {
      setToastVisible(true); // Set toast as visible
      toast.error(
        <div className="toast-ml">
          <h4 className="toast-title">Error!</h4>
          <p className="toast-message">{message}</p>
        </div>,
        {
          onClose: () => setToastVisible(false), // Reset toastVisible on close
          autoClose: 3000, // Optional: auto-close after 3 seconds
        }
      );
    }
  };

  const showSuccessToast = (message) => {
    if (!toastVisible) {
      setToastVisible(true);
      toast.success(
        <div className="toast-ml">
          <h4 className="toast-title">Success!</h4>
          <p className="toast-message">{message}</p>
        </div>,
        {
          onClose: () => setToastVisible(false), // Reset state on close
          autoClose: 3000, // Auto-close after 3 seconds
        }
      );
    }
  };

  const [loadingBoundState, setloadingBoundState] = useState(true);
  const fetchUserDetails = async () => {
    setLoading(true);
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const data = await getUserDetails(token);
        if (data && data.status) {
          const selectedExchange = data.exchanges.find(
            (exchange) => exchange.name === data.exchangeName
          );

          const userDetails = {
            isAuthenticated: true,
            tfaStatus: data.tfastatus,
            email: data.email,
            displayname: data.displayname,
            country: data.country,
            uid: data.uid,
            referralCode: data.referralCode,
            referralUrl: data.referralUrl,
            exchanges: data.exchanges,
            apiKey: selectedExchange?.apiKey || null,
            secretKey: selectedExchange?.secretKey || null,
            exchangeName: selectedExchange?.name || null,
            passPhrase: selectedExchange?.passPhrase || null,
          };

          setUser(userDetails);

          // console.log(userDetails, "User Details Updated");

          if (selectedExchange?.apiKey && selectedExchange?.secretKey) {
            // setLoading(true);
            // setloadingBoundState(true)
            setExchanges((prevExchanges) =>
              prevExchanges.map((exchange) =>
                exchange.name === selectedExchange.name
                  ? {
                      ...exchange,
                      isBounded: true,
                      apiKey: selectedExchange.apiKey,
                      secretKey: selectedExchange.secretKey,
                      passPhrase: selectedExchange.passPhrase,
                    }
                  : exchange
              )
            );
          }
          setLoading(false);
          setloadingBoundState(false);
        }
      } catch (error) {
        // console.error("Error fetching user details:", error);
        setUser({
          isAuthenticated: false,
          tfaStatus: 0,
          email: null,
          uid: null,
          referralCode: null,
          referralUrl: null,
        });
      }
    } else {
      setUser({
        isAuthenticated: false,
        tfaStatus: 0,
        email: null,
        uid: null,
        referralCode: null,
        referralUrl: null,
      });
    }
  };

  useEffect(() => {
    fetchUserDetails();
    fetchExchanges();
  }, []);

  const fetchExchanges = async () => {
    try {
      setLoading(true);
      const data = await getExchanges();
      // console.log(data, "daffsdafasdfsdf");
      if (Array.isArray(data) && data.length > 0) {
        setExchanges(data);
        // Map data to the required options format for Select dropdown
        const exchangeOptions = data.map((exchange) => ({
          value: exchange._id,
          label: exchange.name,
        }));
        setExchangeOptions(exchangeOptions);
        setLoading(false);
      } else {
        // console.error("No exchanges returned from API");
        setExchanges([]);
        setExchangeOptions([]);
        setLoading(false);
      }
    } catch (err) {
      // console.error("Error fetching exchanges:", err);
      setExchanges([]);
      setExchangeOptions([]);
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === " " && !e.ctrlKey && !e.metaKey) {
      e.preventDefault();
    }
  };

  const handleKeyDownApiSecret = (e) => {
    if (e.key === " ") {
      e.preventDefault();
    }
  };

  const [otpLoader, setotpLoader, otpLoaderref] = useState(false);

  const sendOtp = async (index) => {
    setResendLoader(true);
    if (!formStates[index]?.apiKey || !formStates[index]?.secretKey) {
      setResendLoader(false);
      showErrorToast(
        "Please fill in both API Key and Secret Key fields before sending OTP"
      );
      return;
    }

    if (!user.email) {
      setResendLoader(false);
      showErrorToast("User email is not available. Please try again.");
      return;
    }

    try {
      const response = await authService.apibindOtp({ email: user.email });
      // console.log("response", response);
      if (response.data.status) {
        setResendLoader(false);
        showSuccessToast("OTP sent successfully!");
        setOtpSent(true);
        setTimer(120);
      } else {
        setResendLoader(false);
        showErrorToast(
          response.data.Message || "Failed to send OTP. Please try again."
        );
      }
      setotpLoader(false);
    } catch (error) {
      setResendLoader(false);
      showErrorToast("An error occurred. Please try again.");
    }
  };

  const handleCopy = (text) => {
    if (handleCopy.toastVisible) return;

    handleCopy.toastVisible = true;

    if (handleCopy.timeout) clearTimeout(handleCopy.timeout);

    handleCopy.timeout = setTimeout(() => {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          toast.success(
            <div className="toast-ml">
              <h4 className="toast-title">Success!</h4>
              <p className="toast-message"> server IP address copied !</p>
            </div>
          );
        })
        .catch((err) => {
          // console.error("Failed to copy text: ", err);
          toast.error(
            <div className="toast-ml">
              <h4 className="toast-title">Error!</h4>
              <p className="toast-message">Failed to copy text</p>
            </div>
          );
        })
        .finally(() => {
          // Mark toast as not visible anymore after it's been shown
          setTimeout(() => {
            handleCopy.toastVisible = false;
          }, 2000); // Keep the toast for 2 seconds before allowing new one
        });
    }, 300);
  };

  useEffect(() => {
    getPlanDetails();
  }, []);

  const getPlanDetails = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");

      if (!token) {
        setLoading(false);
        return;
      }

      const response = await authService.getPlanDetails(token);

      setLoading(false);
      if (response.data && Array.isArray(response.data)) {
        const activeSubscription = response.data.find((plan) => plan.isActive);

        if (activeSubscription) {
          const { subscriptionName } = activeSubscription;

          if (user?.exchanges?.length >= 3) {
            if (subscriptionName === "Premium") {
              setOnlythree(true);
              // console.log(
              //   "User has 3 or more exchanges:",
              //   user.exchanges.length
              // );
            } else {
              setOnlythree(false);
            }
          }

          if (user?.exchanges?.length >= 1 && subscriptionName === "Freemium") {
            setOnlythree(true);
          } else if (subscriptionName === "Freemium") {
            setOnlythree(false);
          }

          if (subscriptionName === "Promium") {
            setOnlythree(true);
          }

          setPlanDetails(response.data);
        }
      } else {
        setPlanDetails([]);
      }
    } catch (error) {
      setLoading(false);
      // console.error("Error fetching plan details:", error.message);
    }
  };

  useEffect(() => {
    let countdown;
    if (otpSentref.current && timerref.current > 0) {
      countdown = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else if (timerref.current === 0) {
      setOtpSent(false);
      clearInterval(countdown);
    }
    return () => clearInterval(countdown);
  }, [timerref.current, otpSentref.current]);

  const handleInputChange = (e, index, field) => {
    const value = e.target.value.trimStart(); // Trim leading spaces

    //if (value.length > 128) return; // Restrict length to 128 characters

    // Update form state
    setFormStates((prevFormStates) => ({
      ...prevFormStates,
      [index]: {
        ...prevFormStates[index],
        [field]: value,
      },
    }));

    // Field-specific validation
    if (field === "apiKey") {
      if (!value) {
        setFormStates((prevFormStates) => ({
          ...prevFormStates,
          [index]: {
            ...prevFormStates[index],
            apiKeyError: "API Key is required",
          },
        }));
      }
      //  else if (value.length < 20) {
      //   setFormStates((prevFormStates) => ({
      //     ...prevFormStates,
      //     [index]: { ...prevFormStates[index], apiKeyError: "API Key must be at least 20 characters long" },
      //   }));
      // }
      else {
        setFormStates((prevFormStates) => ({
          ...prevFormStates,
          [index]: { ...prevFormStates[index], apiKeyError: "" },
        }));
      }
    }

    if (field === "secretKey") {
      if (!value) {
        setFormStates((prevFormStates) => ({
          ...prevFormStates,
          [index]: {
            ...prevFormStates[index],
            secretKeyError: "Secret Key is required",
          },
        }));
      } else {
        setFormStates((prevFormStates) => ({
          ...prevFormStates,
          [index]: { ...prevFormStates[index], secretKeyError: "" },
        }));
      }
    }

    if (field === "passPhrase") {
      setFormStates((prevFormStates) => ({
        ...prevFormStates,
        [index]: { ...prevFormStates[index], passPhraseError: "" },
      }));
    }
  };
  const handleOtpChange = (e, index) => {
    const value = e.target.value.trim(); // Trim spaces
    if (!/^\d*$/.test(value)) return; // Ensure numeric input

    setFormStates((prevFormStates) => ({
      ...prevFormStates,
      [index]: {
        ...prevFormStates[index],
        verificationCode: value,
      },
    }));

    // OTP validation
    if (!value) {
      setFormStates((prevFormStates) => ({
        ...prevFormStates,
        [index]: {
          ...prevFormStates[index],
          otpError: "OTP is required",
        },
      }));
    } else if (value.length !== 6) {
      setFormStates((prevFormStates) => ({
        ...prevFormStates,
        [index]: {
          ...prevFormStates[index],
          otpError: "OTP should be exactly 6 digits.",
        },
      }));
    } else {
      setFormStates((prevFormStates) => ({
        ...prevFormStates,
        [index]: {
          ...prevFormStates[index],
          otpError: "",
        },
      }));
    }
  };
  const [buttonload, setButtonload, buttonloadref] = useState(false);
  const handleSubmit = async (e, index) => {
    e.preventDefault();
    setButtonload(true);
    const { apiKey, secretKey, passPhrase, verificationCode } =
      formStates[index] || {};
    const currentExchangeName = exchanges[index]?.name;

    let hasError = false;

    // Inline Validation Updates
    setFormStates((prevFormStates) => {
      const updatedForm = { ...prevFormStates };

      // Validate API Key
      if (!apiKey) {
        updatedForm[index] = {
          ...updatedForm[index],
          apiKeyError: "API Key is required",
        };
        hasError = true;
      }
      // else if (apiKey.length < 20) {
      //     updatedForm[index] = {
      //         ...updatedForm[index],
      //         apiKeyError: "API Key must be at least 20 characters long",
      //     };
      //     hasError = true;
      // }
      else {
        updatedForm[index] = { ...updatedForm[index], apiKeyError: "" };
      }

      // Validate Secret Key
      if (!secretKey) {
        updatedForm[index] = {
          ...updatedForm[index],
          secretKeyError: "Secret Key is required",
        };
        hasError = true;
      }
      //  else if (secretKey.length < 20) {
      //     updatedForm[index] = {
      //         ...updatedForm[index],
      //         secretKeyError: "Secret Key must be at least 20 characters long",
      //     };
      //     hasError = true;
      // }
      else {
        updatedForm[index] = { ...updatedForm[index], secretKeyError: "" };
      }

      if (passPhrase != null) {
        updatedForm[index] = { ...updatedForm[index], passPhraseError: "" };
      }

      // Validate OTP
      if (!verificationCode) {
        updatedForm[index] = {
          ...updatedForm[index],
          otpError: "OTP is required",
        };
        hasError = true;
      } else if (verificationCode.length !== 6) {
        updatedForm[index] = {
          ...updatedForm[index],
          otpError: "OTP should be exactly 6 digits",
        };
        hasError = true;
      } else {
        updatedForm[index] = { ...updatedForm[index], otpError: "" };
      }

      return updatedForm;
    });

    // console.log("hasError--->>>", hasError);
    if (hasError) return; // Stop submission if there are validation errors

    try {
      // Verify OTP
      const otpResponse = await authService.verifyBindOtp({
        bindOtp: Number(verificationCode),
      });
      setButtonload(false);
      // console.log(otpResponse, "otpResponse", otpResponse.data);
      if (otpResponse.data?.status == true) {
        // Proceed to store API key if OTP is verified
        const storeResponse = await authService.storeApiKey({
          apiKey,
          secretKey,
          passPhrase,
          exchangeName: currentExchangeName,
        });

        // console.log(storeResponse, "storeResponse");
        if (storeResponse) {
          // Update state on success
          setFormStates((prevFormStates) => ({
            ...prevFormStates,
            [index]: {
              ...prevFormStates[index],
              apiKey: "",
              secretKey: "",
              passPhrase: "",
              verificationCode: "",
              apiKeyError: "",
              secretKeyError: "",
              otpError: "",
              formError: "",
            },
          }));

          // Persist successful changes
          fetchUserDetails();
          localStorage.setItem(`apiKey-${currentExchangeName}`, apiKey);
          localStorage.setItem(`secretKey-${currentExchangeName}`, secretKey);
          localStorage.setItem(`isBounded-${currentExchangeName}`, "true");
          setOtpSent(false);
          showSuccessToast(storeResponse.message);
          setButtonload(false);
          handleBindToggle(index, onlythree, currentExchangeName);
        } else {
          // Handle server errors if response has an error
          const errorMessage = storeResponse?.error || "Unknown server error";
          showErrorToast(errorMessage);
          setButtonload(false);
        }
      } else {
        // Show error if OTP verification fails
        const errorMessage = otpResponse?.Message || "Invalid OTP provided";
        // setFormStates((prevFormStates) => ({
        //     ...prevFormStates,
        //     [index]: {
        //         ...prevFormStates[index],
        //         otpError: errorMessage,
        //     },
        // }));
        showErrorToast(errorMessage);
        setButtonload(false);
      }
    } catch (error) {
      // console.log(error, "0000");
      // Handle network or unexpected errors
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Unexpected error occurred";
      setFormStates((prevFormStates) => ({
        ...prevFormStates,
        [index]: {
          ...prevFormStates[index],
          formError: errorMessage,
        },
      }));
      showErrorToast(errorMessage);
      setButtonload(false);
    }
  };

  useEffect(() => {
    const fetchExchangeDetailsFromUser = () => {
      setLoading(true);

      const updatedExchanges = exchanges.map((exchange) => {
        const userExchange = user.exchanges
          ? user.exchanges.find((e) => e.name === exchange.name)
          : null;

        const apiKey = userExchange ? userExchange.apiKey : "";
        const secretKey = userExchange ? userExchange.secretKey : "";
        const passPhrase = userExchange ? userExchange.passPhrase : "";
        const isBounded = userExchange ? userExchange.isBounded : false;

        return {
          ...exchange,
          apiKey,
          secretKey,
          passPhrase,
          isBounded,
        };
      });
      setLoading(false);

      setExchanges(updatedExchanges);
    };

    if (user && user.exchanges) {
      fetchExchangeDetailsFromUser();
    }
  }, [user]);

  useEffect(() => {
    const userExchanges = user.exchanges || [];

    const initializeFormStates = exchanges.reduce((acc, exchange, index) => {
      const userExchange = userExchanges.find(
        (userExchange) => userExchange.exchangeName === exchange.name
      );
      acc[index] = {
        apiKey: userExchange?.apiKey || "",
        secretKey: userExchange?.secretKey || "",
        passPhrase: userExchange?.passPhrase || "",
        isBounded: userExchange?.isBounded || false,
      };
      return acc;
    }, {});

    setFormStates(initializeFormStates);
  }, [user, exchanges]);

  const [binanceContinuestate, setBinanceContinuestate] = useState(
    new Array(exchanges?.length).fill(false)
  );
  // console.log(binanceContinuestate, "binanceContinuestate");

  const handleContinueClick = (index) => {
    if (planDetails && planDetails.length > 0) {
      // setBinanceContinuestate((prevStates) => {
      //   const updatedStates = [...(prevStates || [])];
      //   updatedStates[index] = true;
      //   return updatedStates;
      // });
      setBinanceContinuestate((prevStates) => {
        const updatedStates = new Array(exchanges.length).fill(false); // Reset all
        updatedStates[index] = true; // Set only the clicked index to true
        return updatedStates;
      });
      setLoading(false);
      setotpLoader(false);
      setResendLoader(false);
      setOtpSent(false);
      setButtonload(false);
      setTimer(120);
    } else {
      showErrorToast("You must activate your plan first.");
    }
  };

  const [selectedIndex, setSelectedIndex, selectedIndexref] = useState(null);

  const handleBindToggle = (index, exchangeName) => {
    if (selectedIndexref.current == index) {
      setSelectedIndex(null); // Close the section if it's already open
    } else {
      setSelectedIndex(index); // Open the clicked section and close the others
    }
    setTimer(0); // Reset timer
    setBinanceContinuestate([]); // Reset continue state for all exchanges
    setFormStates((prevFormStates) => ({
      ...prevFormStates,
      [index]: {
        ...prevFormStates[index],
        isBounded: !prevFormStates[index]?.isBounded, // Toggle the "Bounded" state
      },
    }));

    setExchanges((prevExchanges) =>
      prevExchanges.map((exchange, i) =>
        i === index ? { ...exchange, isBounded: !exchange.isBounded } : exchange
      )
    );
  };

  if (error) return <div>{error}</div>;

  return (
    <div>
      <section>
        <Header />
      </section>

      <div className="api-bind-section">
        <div className="container">
          <div className="row prof_row_sm">
            <div className="col-lg-3 dispaly_none_1200">
              <Sidebar />
            </div>
            <div className="col-xl-9 col-lg-12 deposit_pad_top">
              <div className="row api_main">
                <div className="col-xl-5 col-lg-8 col-md-10 col-sm-9 text-center">
                  <span className="api_top_center">{t("BindExchange")}</span>
                </div>
              </div>
              {loading == true ? (
                <div className="loader_main loader_mainChange">
                  <ScaleLoader color="#20A1FD" height={10} width={3} />
                  <p>{t("Loading")}</p>
                </div>
              ) : (
                <>
                  <div className="api_second_main">
                    {exchanges.map((exchange, index) => {
                      return (
                        <div className="apibind_top_work" key={exchange._id}>
                          <div className="row">
                            <div className="col-4">
                              <div className="api_exchan_head">
                                <img
                                  src={exchange.icon}
                                  alt={exchange.name}
                                  className="api_exchng_img"
                                />
                                <div className="api_exchng_namemain">
                                  <span className="api_exchng_namespan">
                                    {exchange.name}
                                  </span>
                                  <span className="api_exchng_namedefn">
                                    {exchange.description}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="col-4 pad_0_apibind_in">
                              <div className="api_inner_center">
                                {loadingBoundState ? (
                                  // <span className="api_boundchange_span">loading...</span>
                                  <ScaleLoader
                                    color="#20A1FD"
                                    height={5}
                                    width={3}
                                  />
                                ) : user.exchanges?.some(
                                    (userExchange) =>
                                      userExchange.exchangeName ===
                                      exchange.name
                                  ) ? (
                                  <>
                                    <i className="fa-regular fa-circle-check home_user_info_correct"></i>
                                    <span className="api_boundchange_span">
                                      {t("Bounded")}
                                    </span>
                                  </>
                                ) : (
                                  <>
                                    <i
                                      className="bi bi-exclamation-circle home_user_info"
                                      style={{
                                        color: "#ee516d",
                                        marginBottom: "1px",
                                      }}
                                    ></i>
                                    <span className="api_unbound_span">
                                      {t("Unbounded")}
                                    </span>
                                  </>
                                )}
                              </div>
                              {/* <div className="api_inner_center">
                          {user.exchanges?.some(
                            (userExchange) =>
                              userExchange.exchangeName === exchange.name
                          ) ? (
                            <>
                              <i className="fa-regular fa-circle-check home_user_info_correct"></i>
                              <span className="api_boundchange_span">
                                Bounded
                              </span>
                            </>
                          ) : (
                            <>
                              <i
                                className="bi bi-exclamation-circle home_user_info"
                                style={{
                                  color: "#ee516d",
                                  marginBottom: "1px",
                                }}
                              ></i>
                              <span className="api_unbound_span">
                                Unbounded
                              </span>
                            </>
                          )}
                        </div> */}
                            </div>
                            {exchange.status == "active" ? (
                              <div className="col-2 profile_box_divrow">
                                <div className="h-100 d-flex align-items-center">
                                  <button
                                    className="prof_chang_box cursor"
                                    type="button"
                                  >
                                    <span className="prof_chang_box_span">
                                      {t("ComingSoon")}
                                    </span>
                                  </button>
                                </div>
                              </div>
                            ) : (
                              <>
                                <div className="col-4 profile_box_divrow">
                                  {loadingBoundState ? (
                                    <ScaleLoader
                                      color="#20A1FD"
                                      height={5}
                                      width={3}
                                    />
                                  ) : user.exchanges?.some(
                                      (userExchange) =>
                                        userExchange.exchangeName ===
                                        exchange.name
                                    ) ? (
                                    <>
                                      <div className="toggle_profile">
                                        <input
                                          type="checkbox"
                                          id={`toggle-theme${index}`}
                                          className="toggle-check"
                                          onChange={() =>
                                            handleToggle(
                                              index,
                                              exchange.name,
                                              user.exchanges?.some(
                                                (userExchange) =>
                                                  userExchange.exchangeName ===
                                                    exchange.name &&
                                                  userExchange.status === true
                                              )
                                                ? "Disable"
                                                : "Enable"
                                            )
                                          }
                                          checked={user.exchanges?.some(
                                            (userExchange) =>
                                              userExchange.exchangeName ===
                                                exchange.name &&
                                              userExchange.status === true
                                          )}
                                        />
                                        <label
                                          htmlFor={`toggle-theme${index}`}
                                          className="toggle-notification"
                                        ></label>
                                      </div>
                                    </>
                                  ) : (
                                    ""
                                  )}

                                  <div className="h-100 d-flex align-items-center">
                                    <button
                                      className="prof_chang_box"
                                      type="button"
                                      onClick={() =>
                                        handleBindToggle(
                                          index,
                                          onlythree,
                                          exchange.name
                                        )
                                      }
                                    >
                                      <span className="prof_chang_box_span">
                                        {/* {exchange.isBounded ? "Cancel" : "Bind"} */}
                                        {/* {selectedIndexref.current == index ?"Cancel" : "Bind"} */}
                                        {selectedIndexref.current == index
                                          ? "Cancel"
                                          : "Bind"}
                                      </span>
                                    </button>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>

                          {selectedIndexref.current == index ? (
                            <div
                              className="binance_bind_truemain"
                              // style={{
                              //   maxHeight: exchange.isBounded ? "780px" : "0px",
                              //   overflow: "hidden",
                              //   transition: "max-height 1s ease",
                              // }}
                            >
                              <div className="row">
                                <div className="col-lg-6">
                                  {!binanceContinuestate[index] && (
                                    <div className="bina_bind_inimp">
                                      <div className="bina_bind_inimp_top">
                                        <span className="bina_bind_inimp_heading">
                                          {t("Bind")} {exchange.name}{" "}
                                          {t("Exchange")}
                                        </span>
                                        <div className="bin_bind_innersmall">
                                          <div className="bin_bind_innerinnn">
                                            <span className="bin_bind_innerinnn_subhead">
                                              1. {t("Loginto")} {exchange.name}
                                            </span>
                                            <span className="bin_bind_innsubhead_sub">
                                              {t("Goto")}{" "}
                                              <a
                                                href={`https://www.${exchange.name.toLowerCase()}.com`}
                                              >
                                                www.
                                                {exchange.name.toLowerCase()}
                                                .com
                                              </a>{" "}
                                              {t("logIntoYourAccount.")}
                                            </span>
                                          </div>
                                          <div className="bin_bind_innerinnn">
                                            <span className="bin_bind_innerinnn_subhead">
                                              2. {t("CreateAPIKey")}
                                            </span>
                                            <span className="bin_bind_innsubhead_sub">
                                              {t("NavigateTo")}
                                            </span>
                                          </div>
                                          <div className="bin_bind_innerinnn">
                                            <span className="bin_bind_innerinnn_subhead">
                                              3. {t("CopyAPIKey")}
                                            </span>
                                            <span className="bin_bind_innsubhead_sub">
                                              {t("keepThemSecure")}
                                            </span>
                                          </div>
                                          <div className="bin_bind_innerinnn">
                                            <span className="bin_bind_innerinnn_subhead">
                                              4. {t("BindToBinarge")}
                                            </span>
                                            <span className="bin_bind_innsubhead_sub">
                                              {t("LogIntoBinarge")}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        className="bin_bind_submit_div"
                                        onClick={() =>
                                          handleContinueClick(index)
                                        }
                                        // onClick={() => setBinanceContinuestate(true)}
                                      >
                                        <span className="bin_bin_sub_span">
                                          {t("Continue")}
                                        </span>
                                      </div>
                                    </div>
                                  )}
                                  {binanceContinuestate[index] && (
                                    <div className="bina_bind_inimp">
                                      <div className="bina_bind_inimp_top">
                                        <div className="bin_bind_innersmall_next">
                                          <span className="bind_bi_precaution">
                                            {t("Precautions")}
                                          </span>
                                          <span className="bind_bi_precaution_def">
                                            {t("PleaseEnter")}
                                          </span>
                                        </div>
                                        <div className="bin_bind_innersmall_next w-100">
                                          <span className="bind_bi_precaution">
                                            {t("IPGroupBinding")}
                                          </span>
                                          <span className="bind_bi_precaution_def">
                                            {t("ForSecurity")} {exchange.name}{" "}
                                            {t("ExchangeRecommends")}
                                          </span>
                                          <div className="pos_rel w-100">
                                            <input
                                              className="bind_bin_next_inp"
                                              placeholder={exchange.ip}
                                              readOnly
                                            />
                                            <span
                                              className="bind_bin_next_inp_Copy"
                                              onClick={() =>
                                                handleCopy(exchange.ip)
                                              }
                                              style={{ cursor: "pointer" }}
                                            >
                                              {t("Copy")}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="bin_bin_apimain">
                                        <span className="bin_bin_apimain_span">
                                          {t("APIKey")}
                                        </span>
                                        <input
                                          className="bind_bin_next_inp"
                                          placeholder="Please enter API key"
                                          type="text"
                                          value={
                                            formStates[index]?.apiKey || ""
                                          }
                                          onChange={(e) =>
                                            handleInputChange(
                                              e,
                                              index,
                                              "apiKey"
                                            )
                                          }
                                        />
                                        {formStates[index]?.apiKeyError && (
                                          <p className="error">
                                            {formStates[index]?.apiKeyError}
                                          </p>
                                        )}
                                      </div>

                                      <div className="bin_bin_apimain">
                                        <span className="bin_bin_apimain_span">
                                          {t("SecretKey")}
                                        </span>
                                        <input
                                          className="bind_bin_next_inp"
                                          placeholder="Please enter Secret key"
                                          type="text"
                                          value={
                                            formStates[index]?.secretKey || ""
                                          }
                                          onChange={(e) =>
                                            handleInputChange(
                                              e,
                                              index,
                                              "secretKey"
                                            )
                                          }
                                        />
                                        {formStates[index]?.secretKeyError && (
                                          <p className="error">
                                            {formStates[index]?.secretKeyError}
                                          </p>
                                        )}
                                      </div>

                                      <div className="bin_bin_apimain">
                                        <span className="bin_bin_apimain_span">
                                          {t("Passphrase")}
                                        </span>
                                        <input
                                          className="bind_bin_next_inp"
                                          placeholder="Please enter Passphrase"
                                          type="text"
                                          value={
                                            formStates[index]?.passPhrase || ""
                                          }
                                          onChange={(e) =>
                                            handleInputChange(
                                              e,
                                              index,
                                              "passPhrase"
                                            )
                                          }
                                        />
                                      </div>

                                      <div className="bin_bin_apimain">
                                        <span className="bin_bin_apimain_span">
                                          {t("EnterOTP")}
                                        </span>
                                        <div className="pos_rel w-100">
                                          <input
                                            type="text"
                                            maxLength="6"
                                            name="emailOtp"
                                            placeholder="Enter the verification code"
                                            className="bind_bin_next_inp"
                                            value={
                                              formStates[index]
                                                ?.verificationCode || ""
                                            }
                                            onChange={(e) =>
                                              handleOtpChange(e, index)
                                            }
                                            onKeyDown={handleKeyDown}
                                          />

                                          {otpLoaderref.current == true ? (
                                            <span className="bind_bin_next_inp_Copy">
                                              {t("Loading")}
                                            </span>
                                          ) : otpSentref.current ? (
                                            <span className="bind_bin_next_inp_Copy">
                                              {t("Resend")} ({timerref.current}
                                              s)
                                            </span>
                                          ) : (
                                            <>
                                              {resendLoaderref.current ==
                                              false ? (
                                                <span
                                                  className="bind_bin_next_inp_Copy"
                                                  onClick={() => sendOtp(index)}
                                                  style={{ cursor: "pointer" }}
                                                >
                                                  {timerref.current == 120
                                                    ? "Send OTP"
                                                    : "Resend"}
                                                </span>
                                              ) : (
                                                <span
                                                  className="bind_bin_next_inp_Copy"
                                                  style={{
                                                    cursor: "not-allowed",
                                                  }}
                                                >
                                                  {t("Loading")}
                                                </span>
                                              )}
                                            </>
                                          )}
                                        </div>
                                        {formStates[index]?.otpError && (
                                          <p className="error">
                                            {formStates[index]?.otpError}
                                          </p>
                                        )}
                                      </div>

                                      {buttonloadref.current == true ? (
                                        <div className="bin_bind_submit_div">
                                          <span className="bin_bin_sub_span">
                                            {t("Loading")}
                                          </span>
                                        </div>
                                      ) : (
                                        <div
                                          className="bin_bind_submit_div"
                                          onClick={(e) =>
                                            handleSubmit(e, index)
                                          }
                                        >
                                          <span className="bin_bin_sub_span">
                                            {t("Confirm")}
                                          </span>
                                        </div>
                                      )}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      );
                    })}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ApiBind;
//   return (
//     <div>
//       <section>
//         <Header />
//       </section>

//       <div className="api-bind-section">
//         <div className="container">
//           <div className="row prof_row_sm">
//             <div className="col-lg-2 dispaly_none_1200">
//               <Sidebar />
//             </div>
//             <div className="col-xl-10 col-lg-12 deposit_pad_top">
//               <div className="row api_main">
//                 <div className="col-xl-5 col-lg-8 col-md-10 col-sm-9 text-center">
//                   <span className="api_top_center">
//                     Bind Exchange for seamless crypto trading
//                   </span>
//                 </div>
//               </div>
//               <div className="api_second_main">
//                 <div className="apibind_top_work">
//                   {/* <div className="apibind_exchange_main"> */}
//                   <div className="row">
//                     <div className="col-6">
//                       <div className="api_exchan_head">
//                         <img
//                           src={require("../assests/icons/binance-icon.png")}
//                           alt="Binance"
//                           className="api_exchng_img"
//                         />
//                         <div className="api_exchng_namemain">
//                           <span className="api_exchng_namespan">Binance</span>
//                           <span className="api_exchng_namedefn">
//                             Bind Binance for diverse cryptocurrencies and
//                             trading options.
//                           </span>
//                         </div>
//                       </div>
//                     </div>
//                     <div className="col-3 pad_0_apibind_in">
//                       <div className="api_inner_center">
//                         {isBounded ? (
//                           <>
//                             <i class="fa-regular fa-circle-check home_user_info_correct"></i>
//                             <span className="api_boundchange_span">Bounded</span>
//                           </>
//                         ) : (
//                           <>
//                             <i
//                               class="bi bi-exclamation-circle home_user_info"
//                               style={{ color: "#ee516d", marginBottom: "1px" }}
//                             ></i>
//                             <span className="api_unbound_span">Un Bounded</span>
//                           </>
//                         )}
//                       </div>
//                     </div>
//                     <div className="col-3 profile_box_divrow">
//                       <div className="h-100 d-flex align-items-center">
//                         {binanceBindstateref.current == true ? (
//                           <button
//                             className="prof_chang_box"
//                             type="button"
//                             onClick={() => setBinanceBindstate(false)}
//                           >
//                             <span className="prof_chang_box_span">Cancel</span>
//                           </button>
//                         ) : (
//                           <button
//                             className="prof_chang_box"
//                             type="button"
//                             onClick={() => setBinanceBindstate(true)}
//                           >
//                             <span className="prof_chang_box_span">Bind</span>
//                           </button>
//                         )}
//                       </div>
//                     </div>
//                   </div>
//                   {/* {binanceBindstateref.current == true ? ( */}
//                   <div
//                     className=""
//                     style={{
//                       maxHeight: binanceBindstate ? "780px" : "0px", // Adjust maxHeight
//                       overflow: "hidden", // Hide overflowing content when collapsed
//                       transition: "max-height 1s ease", // Smooth transition effect
//                     }}
//                   >
//                     {binanceBindstate ? (
//                       <div className="binance_bind_truemain">
//                         <div className="row">
//                           <div className="col-lg-6">
//                             {binanceContinuestateref.current == false ? (
//                               <div className="bina_bind_inimp">
//                                 <div className="bina_bind_inimp_top">
//                                   <span className="bina_bind_inimp_heading">
//                                     Bind Binance Exchange
//                                   </span>
//                                   <div className="bin_bind_innersmall">
//                                     <div className="bin_bind_innerinnn">
//                                       <span className="bin_bind_innerinnn_subhead">
//                                         1. Log in to Binance
//                                       </span>
//                                       <span className="bin_bind_innsubhead_sub">
//                                         {" "}
//                                         Go to <Link to="">
//                                           www.binance.com
//                                         </Link>{" "}
//                                         and log into your account.
//                                       </span>
//                                     </div>
//                                     <div className="bin_bind_innerinnn">
//                                       <span className="bin_bind_innerinnn_subhead">
//                                         2. Create API Key
//                                       </span>
//                                       <span className="bin_bind_innsubhead_sub">
//                                         {" "}
//                                         Navigate to "API Management," create a
//                                         new API key, and complete the
//                                         verification.
//                                       </span>
//                                     </div>
//                                     <div className="bin_bind_innerinnn">
//                                       <span className="bin_bind_innerinnn_subhead">
//                                         3. Copy API Key and Secret
//                                       </span>
//                                       <span className="bin_bind_innsubhead_sub">
//                                         {" "}
//                                         Copy the API Key and Secret after
//                                         creation; keep them secure.
//                                       </span>
//                                     </div>
//                                     <div className="bin_bind_innerinnn">
//                                       <span className="bin_bind_innerinnn_subhead">
//                                         4. Bind to WY Scale
//                                       </span>
//                                       <span className="bin_bind_innsubhead_sub">
//                                         Log into WY Scale, paste the API Key and
//                                         Secret in the "API Bind" section, and
//                                         save changes.
//                                       </span>
//                                     </div>
//                                   </div>
//                                 </div>
//                                 <div
//                                   className="bin_bind_submit_div"
//                                   onClick={() => setBinanceContinuestate(true)}
//                                 >
//                                   <span className="bin_bin_sub_span">
//                                     Continue
//                                   </span>
//                                 </div>
//                               </div>
//                             ) : (
//                               <div className="bina_bind_inimp">
//                                 <div className="bina_bind_inimp_top">
//                                   <div className="bina_bind_inimp_top_next">
//                                     <span className="bina_bind_inimp_heading">
//                                       Bind Binance Exchange
//                                     </span>
//                                     <div className="bin_bind_innersmall_next">
//                                       <span className="bind_bi_precaution">
//                                         Precautions
//                                       </span>
//                                       <span className="bind_bi_precaution_def">
//                                         Please enter the correct API, please do not enter special characters
//                                       </span>
//                                     </div>
//                                     <div className="bin_bind_innersmall_next w-100">
//                                       <span className="bind_bi_precaution">
//                                         IP group binding
//                                       </span>
//                                       <span className="bind_bi_precaution_def">
//                                         For security purpose, Binance Exchange recommends binding the server IP address when creating the API. For users
//                                       </span>
//                                       <div className="pos_rel w-100">
//                                         <input
//                                           className="bind_bin_next_inp"
//                                           placeholder="35.240.162.178"
//                                           readOnly
//                                         />
//                                         <span
//                                           className="bind_bin_next_inp_Copy"
//                                           onClick={() => handleCopy('35.240.162.178')}
//                                           style={{ cursor: 'pointer' }}
//                                         >
//                                           Copy
//                                         </span>
//                                       </div>
//                                     </div>
//                                   </div>
//                                   <div className="bin_bind_next_inbot">
//                                     <div className="bin_bin_apimain">
//                                       <span className="bin_bin_apimain_span">API Key</span>
//                                       <input
//                                         className="bind_bin_next_inp"
//                                         placeholder="Please enter API key"
//                                         type="text"
//                                         value={apiKey}
//                                         onChange={handleApiKeyChange}
//                                         onKeyDown={handleKeyDownApiSecret}
//                                       />
//                                       {apiKeyError && <div className="error">{apiKeyError}</div>}
//                                     </div>

//                                     <div className="bin_bin_apimain">
//                                       <span className="bin_bin_apimain_span">Secret Key</span>
//                                       <input
//                                         className="bind_bin_next_inp"
//                                         placeholder="Please enter Secret key"
//                                         type="text"
//                                         value={secretKey}
//                                         onChange={handleSecretKeyChange}
//                                         onKeyDown={handleKeyDownApiSecret}
//                                       />
//                                       {secretKeyError && <div className="error">{secretKeyError}</div>}

//                                     </div>
//                                     <div className="bin_bin_apimain">
//                                       <span className="bin_bin_apimain_span">Enter OTP</span>
//                                       <div className="pos_rel w-100">
//                                         <input
//                                           type="text"
//                                           maxLength="6"
//                                           name="emailOtp"
//                                           placeholder="Enter the verification code"
//                                           className="bind_bin_next_inp"
//                                           value={verificationCode}
//                                           onChange={handleOtpChange}
//                                           onKeyDown={handleKeyDown}     // Restrict non-numeric input
//                                         />
//                                         {otpSent ? (

//                                           <span className="bind_bin_next_inp_Copy">Resend ({timer}s)</span>
//                                         ) : (
//                                           <span
//                                             className="bind_bin_next_inp_Copy"
//                                             onClick={sendOtp}  // Send OTP
//                                             style={{ cursor: 'pointer' }}
//                                           >
//                                             {timer === 120 ? "Send OTP" : "Resend"}
//                                           </span>
//                                         )}
//                                       </div>
//                                       {otpError && verificationCode.length !== 6 && (
//                                         <p className="error">OTP should be exactly 6 digits.</p>
//                                       )}
//                                     </div>
//                                   </div>
//                                 </div>
//                                 <div
//                                   className="bin_bind_submit_div"
//                                   onClick={(e) => {
//                                     e.preventDefault(); // Prevent default form submission
//                                     setBinanceBindstate(true);
//                                     handleSubmit(e); // Pass the event to handleSubmit
//                                   }}
//                                 >
//                                   <span className="bin_bin_sub_span">Confirm</span>
//                                 </div>

//                               </div>

//                             )}
//                           </div>
//                         </div>
//                       </div>
//                     ) : null}
//                   </div>
//                   {/* ) : ("")} */}
//                 </div>

//                 <div className="apibind_top_work">
//                   {/* <div className="apibind_exchange_main"> */}
//                   <div className="row">
//                     <div className="col-6">
//                       <div className="api_exchan_head">
//                         <img
//                           src={require("../assests/icons/bybit-icon.png")}
//                           alt="Binance"
//                           className="api_exchng_img"
//                         />
//                         <div className="api_exchng_namemain">
//                           <span className="api_exchng_namespan">Bybit</span>
//                           <span className="api_exchng_namedefn">
//                             Connect with Bybit for a wide range of
//                             cryptocurrencies and trading features.
//                           </span>
//                         </div>
//                       </div>
//                     </div>
//                     <div className="col-3 pad_0_apibind_in">
//                       <div className="api_inner_center">
//                         <i
//                           class="bi bi-exclamation-circle home_user_info"
//                           style={{ color: "#ee516d", marginBottom: "1px" }}
//                         ></i>
//                         <span className="api_unbound_span">Un Bounded</span>
//                       </div>
//                     </div>
//                     <div className="col-3 profile_box_divrow">
//                       <div className="h-100 d-flex align-items-center">
//                         <button className="prof_chang_box" type="button">
//                           <span className="prof_chang_box_span">Change</span>
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="apibind_top_work">
//                   {/* <div className="apibind_exchange_main"> */}
//                   <div className="row">
//                     <div className="col-6">
//                       <div className="api_exchan_head">
//                         <img
//                           src={require("../assests/icons/kucoin-icon.png")}
//                           alt="Binance"
//                           className="api_exchng_img"
//                         />
//                         <div className="api_exchng_namemain">
//                           <span className="api_exchng_namespan">Kucoin</span>
//                           <span className="api_exchng_namedefn">
//                             Link with KuCoin for a variety of cryptocurrencies
//                             and trading tools.
//                           </span>
//                         </div>
//                       </div>
//                     </div>
//                     <div className="col-3 pad_0_apibind_in">
//                       <div className="api_inner_center">
//                         <i class="fa-regular fa-circle-check home_user_info_correct"></i>
//                         <span className="api_boundchange_span">Bounded</span>
//                       </div>
//                     </div>
//                     <div className="col-3 profile_box_divrow">
//                       <div className="h-100 d-flex align-items-center">
//                         <button className="prof_chang_box" type="button">
//                           <span className="prof_chang_box_span">Change</span>
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="apibind_top_work">
//                   {/* <div className="apibind_exchange_main"> */}
//                   <div className="row">
//                     <div className="col-6">
//                       <div className="api_exchan_head">
//                         <img
//                           src={require("../assests/icons/gateio-icon.png")}
//                           alt="Binance"
//                           className="api_exchng_img"
//                         />
//                         <div className="api_exchng_namemain">
//                           <span className="api_exchng_namespan">gate.io</span>
//                           <span className="api_exchng_namedefn">
//                             Connect with Gate.io for a diverse range of
//                             cryptocurrencies and trading.
//                           </span>
//                         </div>
//                       </div>
//                     </div>
//                     <div className="col-3 pad_0_apibind_in">
//                       <div className="api_inner_center">
//                         <i
//                           class="bi bi-exclamation-circle home_user_info"
//                           style={{ color: "#ee516d", marginBottom: "1px" }}
//                         ></i>
//                         <span className="api_unbound_span">Un Bounded</span>
//                       </div>
//                     </div>
//                     <div className="col-3 profile_box_divrow">
//                       <div className="h-100 d-flex align-items-center">
//                         <button className="prof_chang_box" type="button">
//                           <span className="prof_chang_box_span">Change</span>
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <ToastContainer />
//     </div>
//   );
// }
